export default [
  {
    path: '/zaercard',
    name: 'zaercard',
    component: () => import('@/views/menu/zaercard/zaercard.vue'),
    meta: {
      pageTitle: 'مدیریت زائرکارت',
      action: 'show',
      resource: 'ZaerCardManager',
    },
  },
]
